export const DNS_ZONE_INFO =
  'Select the DNS zone to automatically register a DNS record for this network. Ensure DNS is enabled and zones are configured.'

export const MAKE_SHARED_INFO = 'If checked, network will be available for every tenant.'

export const MANAGED_NETWORK_INFO =
  'Includes IP management, subnets, DHCP, and routing. Recommended for most workloads.'

export const SIMPLE_NETWORK_TOOLTIP_INFO =
  'Layer 2 network only. No subnet, DHCP, or IP management — configure IPs inside the VM.'

export enum NetworkType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

// Simple Networks (L2-only) Constants
// Note: UI labels show "Simple Network" in user-facing text
export const SIMPLE_NETWORK_INFO =
  'Layer 2 Networks provide direct Layer 2 connectivity without OpenStack-managed IP addressing. IP configuration must be done inside the guest OS using static assignment or an external DHCP server.'

export const SIMPLE_NETWORK_VM_WARNING =
  'IP address must be configured inside the guest OS. Use static assignment or external DHCP server.'

export const SIMPLE_NETWORK_CUSTOMIZE_WARNING =
  'Some customization options are disabled because a Layer 2 Network is selected. Cloud-init, SSH keys, and security groups are not applicable for Layer 2 Networks.'

export enum NetworkMode {
  MANAGED = 'managed',
  SIMPLE = 'simple',
}

// Badge variants for network types
// Note: text labels show "Layer 2 Network" for user-facing display
export const NETWORK_BADGE_VARIANTS = {
  [NetworkMode.SIMPLE]: { variant: 'default', color: 'teal', text: 'Layer 2 Network' },
  [NetworkMode.MANAGED]: { variant: 'primary', color: 'blue', text: 'Managed Network' },
}
